import { useEffect } from 'react';
import { useAppStore } from './store/useAppStore';
import { useSettingsStore } from './store/useSettingsStore';
import AppHeader from './components/AppHeader';
import OrderForm from './components/OrderForm';
import CustomerQueue from './components/CustomerQueue';
import CustomerBakingBanner from './components/CustomerQueue/CustomerBakingBanner';
import BakerQueue from './components/BakerQueue';
import { useOrderAlerts } from './hooks/useOrderAlerts';
import { useStockNotices } from './hooks/useStockNotices';

function App() {
  const mode = useSettingsStore((state) => state.mode);
  const setBakerPin = useSettingsStore((state) => state.setBakerPin);
  const setNow = useAppStore((state) => state.setNow);
  const loadConfig = useAppStore((state) => state.loadConfig);
  const loadOrders = useAppStore((state) => state.loadOrders);
  const connectSse = useAppStore((state) => state.connectSse);
  const disconnectSse = useAppStore((state) => state.disconnectSse);
  const checkAuthStatus = useAppStore((state) => state.checkAuthStatus);
  const setSessionId = useSettingsStore((state) => state.setSessionId);

  useOrderAlerts();
  useStockNotices();

  useEffect(() => {
    loadConfig();
    loadOrders();
    connectSse();
    checkAuthStatus();
    return () => disconnectSse();
  }, [checkAuthStatus, connectSse, disconnectSse, loadConfig, loadOrders]);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        checkAuthStatus();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, [checkAuthStatus]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pin = params.get('bakerPin');
    const session = params.get('sessionId');
    if (pin) {
      setBakerPin(pin);
    }
    if (session) {
      setSessionId(session);
    }
    if (pin || session) {
      params.delete('bakerPin');
      params.delete('sessionId');
      const query = params.toString();
      window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
      checkAuthStatus();
    }
  }, [checkAuthStatus, setBakerPin, setSessionId]);

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [setNow]);

  const pagePad = 'px-4 sm:px-6';

  return (
    <div className="min-h-screen min-h-dvh" style={{ backgroundColor: 'var(--app-bg)', color: 'var(--app-text)' }}>
      <AppHeader />

      <div className="mx-auto max-w-6xl">
        {mode === 'orders' ? (
          <section>
            <CustomerBakingBanner />
            <div className={`${pagePad} py-4`}>
              <CustomerQueue />
            </div>
          </section>

        ) : mode === 'menu' ? (
          <div className={`${pagePad} max-w-2xl py-5`}>
            <OrderForm />
          </div>

        ) : (
          <div className="py-4">
            <BakerQueue />
          </div>
        )}
      </div>
    </div>
  );
}

export default App;